<template>
  <AppFilterToolbar>
    <template #primary>
      <AppInput id="automation-search" :value="filters.search" design="new" type="search" placeholder="Run, lead, name, email or phone" aria-label="Search" :maxlength="255" @input="$emit('search', $event)" />
    </template>
    <AppSelect v-for="field in selectFields" :key="field.key" :value="filters[field.key]" design="new" :input-id="field.id" :aria-label="field.label" :options="options.data ? options.data[field.options] : []" :disabled="!options.data" :reduce="field.reduce" :placeholder="field.label" @input="$emit('change', { [field.key]: $event })" />
    <AppDatePicker v-for="field in dateFields" :key="field.key" :value="filters[field.key]" design="new" :input-attr="{ id: field.id, 'aria-label': field.label }" :placeholder="field.label" @input="$emit('change', { [field.key]: $event })" />
    <template #selection><AppFilters design="new" refined weight="medium" name="automation-view" aria-label="Run selection" :filters="views" :value="filters.view" @change="$emit('change', { view: $event })" /></template>
    <template #actions>
      <AppIconButton label="How it works" tooltip-placement="left" :disabled="!options.data" @click="$emit('guide')"><i class="pi pi-info-circle" aria-hidden="true" /></AppIconButton>
      <AppRefreshButton :loading="refreshing" @click="$emit('refresh')" />
    </template>
    <template v-if="hasFilters" #clear><AppClearFiltersButton design="new" icon-only @clear="$emit('clear')" /></template>
  </AppFilterToolbar>
</template>
<script>
import { VIEWS } from './model'
import AppRefreshButton from '@/components/AppRefreshButton.vue'

export default {
  name: 'FollowUpAutomationFilters',
  components: { AppRefreshButton },
  props: {
    filters: { type: Object, required: true },
    summary: { type: Object, required: true },
    options: { type: Object, required: true },
    refreshing: Boolean
  },
  data: () => ({
    selectFields: [
      {
        key: 'stage',
        id: 'automation-stage',
        label: 'Stage at start',
        options: 'stages',
        placeholder: 'All stages',
        reduce: (item) => item.code
      },
      {
        key: 'manager_id',
        id: 'automation-manager',
        label: 'Manager at start',
        options: 'managers',
        placeholder: 'All managers',
        reduce: (item) => String(item.id)
      },
      {
        key: 'provider',
        id: 'automation-provider',
        label: 'Provider',
        options: 'providers',
        placeholder: 'All providers',
        reduce: (item) => item.code
      },
      {
        key: 'attention_category',
        id: 'automation-attention-category',
        label: 'Attention category',
        options: 'attention_categories',
        placeholder: 'All categories',
        reduce: (item) => item.code
      }
    ],
    dateFields: [
      { key: 'date_from', id: 'automation-from', label: 'Started from' },
      { key: 'date_to', id: 'automation-to', label: 'Started through' }
    ]
  }),
  computed: {
    hasFilters() { return Boolean(this.filters.search || this.filters.stage || this.filters.manager_id || this.filters.provider || this.filters.attention_category || this.filters.date_from || this.filters.date_to || this.filters.view !== 'all') },
    views() {
      return VIEWS.map((view) => ({
        ...view,
        label: `${view.label} (${this.summary.data?.[view.value] ?? (this.summary.loading ? '…' : '—')})`
      }))
    }
  }
}
</script>
